/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { GetWalletInfoQueryResponse, GetWalletInfo400, GetWalletInfo401 } from "../entities/GetWalletInfo";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { getWalletInfo } from "../api/getWalletInfo";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getWalletInfoQueryKey = () => [{ url: '/api/v1/account/wallet' }] as const

export type GetWalletInfoQueryKey = ReturnType<typeof getWalletInfoQueryKey>

export function getWalletInfoQueryOptions(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = getWalletInfoQueryKey()
        return queryOptions<GetWalletInfoQueryResponse, ResponseErrorConfig<GetWalletInfo400 | GetWalletInfo401>, GetWalletInfoQueryResponse, typeof queryKey>({
         
         queryKey,
         queryFn: async ({ signal }) => {
            return getWalletInfo({ ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Получает информацию о балансе и платежных методах пользователя.
 * **Требования:**
 * - Аутентификация по заголовкам `user-id` и `city-id`
 * **Процесс:**
 * 1. Получение информации о балансе из БД и платежных методах
 * 2. Возврат информации о балансе и платежных методах
 * **Пояснение по объектам:**
 * - balance:
 * - amount: Сумма баланса в копейках
 * - currency: Валюта баланса
 * - topup:
 * - presets: Массив дефолтных сумм платежа
 * - payment_methods: Массив платежных методов
 * - id: ID платежного метода
 * - title: Название платежного метода
 * - is_available: Флаг доступности платежного метода
 * - unavailable_reason: Описание недоступности платежного метода
 * - limits: Объект с минимальной и максимальной суммой платежа в копейках
 * - min: Минимальная сумма платежа
 * - max: Максимальная сумма платежа
 * @summary Получение информации о балансе и платежных методах
 * {@link /api/v1/account/wallet}
 */
export function useGetWalletInfo<TData = GetWalletInfoQueryResponse, TQueryData = GetWalletInfoQueryResponse, TQueryKey extends QueryKey = GetWalletInfoQueryKey>(options: 
{
  query?: Partial<QueryObserverOptions<GetWalletInfoQueryResponse, ResponseErrorConfig<GetWalletInfo400 | GetWalletInfo401>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? getWalletInfoQueryKey()
         

         const query = useQuery({
          ...getWalletInfoQueryOptions(config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetWalletInfo400 | GetWalletInfo401>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}